"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.historySchema = void 0;
const zod_1 = require("zod");
exports.historySchema = zod_1.z.object({
    changes: zod_1.z.array(zod_1.z.object({ by: zod_1.z.string(), at: zod_1.z.number() })).optional(),
    recovered: zod_1.z.boolean().optional(),
});
